/**
 * Bilingual copy for the CtaBanner component defaults.
 * Titles/descriptions and optional button labels arrive as props from callers.
 * `en` holds the exact original English default string; `km` mirrors it in Khmer.
 */
export const en = {
  defaultPrimaryLabel: 'Request a demo',
  defaultPrimaryTo: '/contact',
};

export type Copy = typeof en;

export const km: Copy = {
  defaultPrimaryLabel: 'សុំ Demo',
  defaultPrimaryTo: '/contact',
};
